import { createContext } from "react";

interface ITableHistoryContext {
  onGenerateCurrentState: () => void;
}

export const TableHistoryContext = createContext<ITableHistoryContext>({
  onGenerateCurrentState: () => {},
});
